<template>
	<div></div>
</template>

<script>
export default {
	name: "UserBecome",
	watch: {
		currentUser(user) {
			if (user) {
				window.location.replace("/");
			}
		}
	},
	mounted() {
		const { token, become } = this.$route.params;

		if (window.localStorage) {
			if (become) {
				window.localStorage.setItem("impersonation", true);
			}
			window.localStorage.setItem("token", token);
		}
	}
};
</script>
